// import React from 'react';
// import loadable from '@loadable/component';

// const CardDigitalVar1Component = (props) => {
//   const Component = loadable(() => import('./CardDigitalVar1Component.js'), { ssr: false });
//   return <Component {...props} />;
// };

// export default CardDigitalVar1Component;

import React from 'react';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import ReactPlayer from 'react-player';
import useWindowSize from '../Shared/hooks/useWindowSize';
import ButtonsContainer from '../Shared/components/ButtonsContainer';
import clsx from 'clsx';
import './style.scss';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CardDigitalVar1Component = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CardDigitalVar1Component" />;
  }
  const { params, fields } = props;
  const { text, image, youtubeId, vimeoId, video, items, heading } = fields;
  //render conditions
  const shoudRenderImage =
    !!image && image?.value?.src !== null && image?.value?.src !== '' && !!image?.value?.src;
  const shoudRenderText = !!text && text?.value !== '';
  const shoudRenderHeader = !!heading && heading?.value !== '';
  //video
  let videoYoutubeSource = youtubeId?.value;
  let videoVimeoSource = vimeoId?.value;
  let videoSource = video?.value?.src;
  const shouldRenderYoutube = !!videoYoutubeSource && videoYoutubeSource !== '';
  const shouldRenderVimeo = !!videoVimeoSource && videoVimeoSource !== '' && !shouldRenderYoutube;
  const shouldRenderVideo =
    !shouldRenderVimeo &&
    !shouldRenderYoutube &&
    !!videoSource &&
    videoSource !== '' &&
    videoSource !== null;
  const shouldRenderAnyTypeOfVideo =
    !shoudRenderImage && (shouldRenderYoutube || shouldRenderVimeo || shouldRenderVideo);

  //returned data
  const isEliteTheme = props?.fields?.IsEliteTheme?.value;
  return (
    <div
      className={clsx(
        'cardDigital',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        params?.Styles
      )}
    >
      <div
        className={clsx(
          'wrap content flex-it',
          !!params?.mediaOnTheRight &&
            params?.mediaOnTheRight !== null &&
            params?.mediaOnTheRight === '1'
            ? 'mediaAtRightSide'
            : ''
        )}
      >
        <div className="cardDigital__media flex-it flex-justify-center flex-align-item-center">
          {shouldRenderAnyTypeOfVideo && <VideoComponent props={props} />}
          {shoudRenderImage && (
            <figure>
              <Image field={image} />
            </figure>
          )}
        </div>
        <div className="cardDigital__text flex-it flex-justify-center flex-align-item-center flex-wrap">
          <div className="auto">
            {shoudRenderHeader && (
              <div className="richText richTextCss header">
                <Text field={heading} />
              </div>
            )}
            {shoudRenderText && <RichText className="richText richTextCss" field={text} />}
            <ButtonsContainer items={items} className="wrapButtons" />
          </div>
        </div>
      </div>
    </div>
  );
};

const VideoComponent = ({ props }) => {
  const [width] = useWindowSize();
  const { youtubeId, vimeoId, video, videoThumbnail: thumbnail } = props?.fields;

  let videoYoutubeSource = youtubeId?.value;
  let videoVimeoSource = vimeoId?.value;
  let videoSource = video?.value?.src;

  const shouldRenderYoutube = !!videoYoutubeSource && videoYoutubeSource !== '';
  const shouldRenderVimeo = !!videoVimeoSource && videoVimeoSource !== '' && !shouldRenderYoutube;
  const shouldRenderVideo = !shouldRenderVimeo && !shouldRenderYoutube && videoSource !== '';

  return (
    <div className="video-component">
      {shouldRenderVimeo && (
        <div className="fullscreen">
          <div className="video">
            <div className="wrapper">
              <iframe
                title=" "
                style={{ minHeight: width / 1.5 + 'px' }}
                src={`//player.vimeo.com/video/${videoVimeoSource}?autoplay=1&loop=1&title=0&byline=0&portrait=0`}
                frameBorder="0"
                allowFullScreen
                sandbox
              />
            </div>
          </div>
        </div>
      )}

      {shouldRenderVideo && (
        <div className={`videoItem videop`}>
          {
            <ReactPlayer
              url={videoSource}
              loop={false}
              controls={true}
              volume={5}
              muted={false}
              playing={false}
              playsinline={true}
              light={thumbnail?.value?.src}
            />
          }
        </div>
      )}

      {shouldRenderYoutube && (
        <div className={`videoItem youtube`}>
          {
            <ReactPlayer
              url={`//www.youtube.com/embed/${videoYoutubeSource}`}
              loop={false}
              controls={true}
              volume={5}
              muted={false}
              playing={false}
              playsinline={true}
              light={thumbnail?.value?.src}
            />
          }
        </div>
      )}
    </div>
  );
};
export default CardDigitalVar1Component;
